import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useUserEmail from "@/shared/hooks/useUserEmail";

import NavigationMobile from "../Navigation/NavigationMobile";
import HeaderLogo from "../HeaderLogo";
import Icon from "../../../../shared/components/Icon/Icon";
import Styles from "../Navigation/NavigationDesktop.module.scss";
import HeaderStyles from "../Header.module.scss";
import classNames from "classnames";
import { useTheme } from "@/shared/styles/useTheme";
import { getUserId } from "@/api/localStorage";
import { isAllowedRAFRoute } from "@/shared/utils/utils";
import { checkReferralEligibility } from "@/api/referral";
import { useQuery } from "react-query";
const isNewLayout = location.pathname.includes("wechselservice-sieger-fuer-strom-und-gas");

export const HeaderMobile = () => {
  const { navbar } = useTheme();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const userID = getUserId();
  const navigate = useNavigate();
  const userEmail = useUserEmail();
  // Close dropdown menu when location changes
  useEffect(() => {
    setOpen(false);
  }, [location]);

  const close = () => {
    setTimeout(() => setOpen(false), 300);
  };
  const { data: eligibilityData } = useQuery(["referral-eligibility", userID], () => checkReferralEligibility(userID), {
    enabled: !!userID,
  });

  const showReferral = eligibilityData?.showRef;
  const isAllowedRoute = isAllowedRAFRoute(location.pathname);
  return (
    <div className={classNames(HeaderStyles.headerMainContainer, { [HeaderStyles.newLayout]: isNewLayout })}>
      <HeaderLogo />
      <div className={Styles.moveRight}>
        {showReferral && isAllowedRoute && (
          <Icon
            className={classNames(Styles.clickableIcon, navbar.item)}
            name="giftMobile"
            size="37px"
            onClick={() => {
              navigate(`/mein-remindme/freunde-werben-freunde?email=${userEmail}&autoDetect=1`);
            }}
          />
        )}
        <Icon
          className={classNames(Styles.clickableIcon, navbar.item)}
          name="menu"
          size="37px"
          onClick={() => setOpen(true)}
        />
      </div>
      {open && <NavigationMobile close={close} />}
    </div>
  );
};
